export enum QuizQuestionType {
  Checkbox
}
